import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreateRefundRequest } from '@control-center/shared';

import { createRefund, fetchRefundsByCharge } from '../lib/refunds-api';
import { chargesKeys } from './use-charges';

export const refundsKeys = {
  all: ['refunds'] as const,
  byCharge: (chargeId: string) => [...refundsKeys.all, 'byCharge', chargeId] as const,
};

export function useRefundsByCharge(chargeId: string | undefined) {
  return useQuery({
    queryKey: refundsKeys.byCharge(chargeId ?? ''),
    queryFn: () => fetchRefundsByCharge(chargeId as string),
    enabled: Boolean(chargeId),
    staleTime: 30_000,
  });
}

export function useCreateRefund() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateRefundRequest) => createRefund(payload),
    onSuccess: (_data, variables) => {
      // Invalida lista de refunds + charge detail (saldo restante muda) + lista charges
      qc.invalidateQueries({ queryKey: refundsKeys.byCharge(variables.chargeId) });
      qc.invalidateQueries({ queryKey: chargesKeys.detail(variables.chargeId) });
      qc.invalidateQueries({ queryKey: chargesKeys.lists() });
    },
  });
}
